import { DRAWER_TOGGLE } from '../constants/ActionTypes'

const initialState = {
  open: false
}

const ReducerDrawer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DRAWER_TOGGLE: {
      return { ...state, open: !state.open }
    }
    default: return state
  }
}

export default ReducerDrawer